// ERP Attribute Engine — Attribute Engine (validation)
const VALIDATORS = {
  sellingPriceLteMrp: (value, values) => {
    const mrp = Number(values['mrp']);
    const sp = Number(value);
    if (!isNaN(mrp) && !isNaN(sp) && mrp > 0 && sp > mrp)
      return `Selling price (₹${sp}) cannot exceed MRP (₹${mrp}).`;
    return null;
  },
  salePriceLtSellingPrice: (value, values) => {
    const sp = Number(values['selling_price']);
    const sale = Number(value);
    if (!isNaN(sp) && !isNaN(sale) && sp > 0 && sale >= sp)
      return `Sale price (₹${sale}) must be less than selling price (₹${sp}).`;
    return null;
  },
};

export const AttributeEngine = {
  validate(attr, value, allValues = {}, isRequiredOverride) {
    if (attr.readOnly) return null;

    const rule = attr.validation || {};
    const label = attr.label;
    const isRequired = isRequiredOverride !== undefined ? isRequiredOverride : !!rule.required;

    const isEmpty =
      value === undefined || value === null || value === '' ||
      (Array.isArray(value) && value.length === 0);

    if (isRequired && isEmpty) return rule.message || `${label} is required.`;
    if (isEmpty) return null;

    if (attr.type === 'number' || attr.type === 'decimal' || attr.type === 'currency') {
      const num = Number(value);
      if (isNaN(num)) return `${label} must be a valid number.`;
      if (rule.min !== undefined && num < rule.min) return `${label} must be at least ${rule.min}.`;
      if (rule.max !== undefined && num > rule.max) return `${label} must not exceed ${rule.max}.`;
    }

    if (typeof value === 'string') {
      if (rule.minLength !== undefined && value.length < rule.minLength)
        return `${label} must be at least ${rule.minLength} characters.`;
      if (rule.maxLength !== undefined && value.length > rule.maxLength)
        return `${label} must not exceed ${rule.maxLength} characters.`;
      if (rule.pattern) {
        const regex = new RegExp(rule.pattern);
        if (!regex.test(value)) return rule.patternMessage || `${label} format is invalid.`;
      }
    }

    if (attr.type === 'date' && rule.futureDate) {
      const date = new Date(value);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      if (date <= now) return `${label} must be a future date.`;
    }

    if ((attr.type === 'image-url') && typeof value === 'string') {
      try { new URL(value); } catch { return `${label} must be a valid URL.`; }
    }

    if (rule.custom && VALIDATORS[rule.custom])
      return VALIDATORS[rule.custom](value, allValues);

    return null;
  },

  validateForm(attributeMap, visibleAttributeIds, values, requiredOverrides, unrequiredOverrides) {
    const errors = {};
    for (const id of visibleAttributeIds) {
      const attr = attributeMap.get(id);
      if (!attr) continue;
      const isRequired =
        (!!attr.validation?.required || requiredOverrides.has(id)) &&
        !unrequiredOverrides.has(id);
      const err = this.validate(attr, values[id], values, isRequired);
      if (err) errors[id] = err;
    }
    return errors;
  },

  formatValue(attr, value) {
    if (value === undefined || value === null) return '-';
    if (attr.type === 'boolean') return value ? 'Yes' : 'No';
    if ((attr.type === 'number' || attr.type === 'currency') && attr.unit) return `${attr.unit} ${value}`;
    if (Array.isArray(value)) return value.join(', ');
    return String(value);
  }
};
